import 'lite-youtube-embed/src/lite-yt-embed';
import 'lite-vimeo-embed/lite-vimeo-embed';
import paginationJS from './pagination';
import navbarItems from './nav';
import searchWindow from './search';
import validationErrors from './validation';
import contentUpdates from './content-updater';
import smoothScrolling from './smooth-scrolling';
import videoTranscript from './captions';
import galleryCarousel from './gallery-carousel';
import galleryPopup from './gallery-popup';
import feedFilter from './feed-filter';
import calculatorBlock from './calculator-block';
import listingFilter from './listing-filter';

window.Popper = require('popper.js');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

require('bootstrap/dist/js/bootstrap.min');
require('modaal/dist/js/modaal.min');

require('./swiped-events.min');
require('hammerjs');

// Your custom JavaScript can be added below
$(document).ready(() => {
  // Notification bar goes first
  $('#notification-alert').click(() => {
    $('#notification-bar').slideUp('100');
    sessionStorage.setItem('notify', 'hide');

    const xhttp = new XMLHttpRequest();
    xhttp.open("POST", "/home/hideNotificationBar");
    xhttp.send();
  });

  $('.skip_link').click((e) => {
    e.preventDefault();
    $('#skip').focus();
  });
});

// call this function on page load
paginationJS();
navbarItems();
searchWindow();
validationErrors();
contentUpdates();
smoothScrolling();
videoTranscript();
galleryCarousel();
galleryPopup();
feedFilter();
calculatorBlock();
listingFilter();

$(document).ready(() => {
  // Apply modaal to all present gallery .inline
  $('.inline').each(function () {
    const targetAttr = $(this).attr('data-content');
    $(this).modaal({
      content_source: `#${targetAttr}`,
      close_aria_label: 'Press escape to close',
//      accessible_title: 'Modal Opened.',
      animation_speed: 750,
      after_callback_delay: 750,

    });
  });

  // $('.selectpicker').selectpicker();

  let win = $(window),
    header = $('header'),
    pos = header.offset().top,
    sticky = function () {
      // disable sticky for window greater than 960
      win.scrollTop() > pos && window.innerWidth > 960 ?
        header.addClass('sticky')
        : header.removeClass('sticky');
    };

  win.scroll(sticky);

  window.addEventListener('resize', () => {
    sticky();
  });
});

// Back to top button scroll
$(document).ready(() => {
  // scroll body to 0px on click
  $('#back-to-top').click(() => {
    const alertSection = $('#alert-section');
    alertSection.children().remove();
    alertSection.append('<p role="alert">Focus has been moved to the start of the page</p>');

    $('body,html').animate({
      scrollTop: 0,
    }, 400);

    setTimeout(() => {
      $('.skip_link').click();
    }, 400);

    return false;
  });

  // applyGrid();
  setTimeout(() => {
    $('.grid').each(function () {
      applyGrid($(this));
    });
  }, 500);
});

function applyGrid(grid) {
  if (grid) {
    grid.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
        horizontalOrder: true,
      },
    });
  }
}

require('isotope-layout/dist/isotope.pkgd.min');



// WEBPACK FOOTER //
// ./themes/app/src/js/app.js